import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('production-timeline/index', {params});
    },
    getMaterialCategoryPR(params) {
        return Service().get('production-timeline/get-production-timeline', {params});
    },
    show(id) {
        return Service().get('production-timeline/show/'+id);
    },
    create(params) {
        return Service().post('production-timeline/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('production-timeline/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('production-timeline/delete/'+id);
    },
}